export var DEFAULT_ZONE_POINT = [37.62251, 55.753219];
